export const iconFontAwesomeShoppingBell = (
	<i className="fa-solid fa-bell"></i>
);
